import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";

const VerComentarios = ({ id }) => {
  const [list1, setList1] = useState([]);
  const [expandedStates, setExpandedStates] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const urlendpoint = `https://contratosback.azurewebsites.net/api/v1/ObtenerComentarios/${id}`;

  useEffect(() => {
    const fetchComments = () => {
      axios({
        auth: {
          username: "admin.icontec@icontec.org",
          password: "quAngEraMuSTerGerE",
        },
        method: "get",
        url: urlendpoint,
      })
        .then((res) => {
          if (Array.isArray(res.data)) {
            const sorted = res.data.sort(
              (a, b) => new Date(b.fechaCreacion) - new Date(a.fechaCreacion),
            );
            setList1(sorted);
          } else {
            console.error("Datos inesperados:", res.data);
          }
        })
        .catch((error) => {
          console.error("Error al obtener los comentarios:", error);
        });
    };

    fetchComments();
    const interval = setInterval(fetchComments, 10000);
    return () => clearInterval(interval);
  }, [id]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list1.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.max(Math.ceil(list1.length / itemsPerPage), 1);

  const toggleExpanded = (id) => {
    setExpandedStates((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <Container className="mt--5" fluid>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0">
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <h3 className="mb-0">Comentarios de la solicitud</h3>
            </CardHeader>
            <Table className="table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th style={{ width: "30%" }}>Usuario / Fecha</th>
                  <th style={{ width: "70%" }}>Comentario</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => {
                    const isExpanded = expandedStates[item.id] || false;
                    const maxCharacters = 100;

                    const needsTruncation =
                      item.comentarios.length > maxCharacters;
                    const displayText = isExpanded
                      ? item.comentarios
                      : item.comentarios.slice(0, maxCharacters) +
                        (needsTruncation ? "..." : "");

                    return (
                      <tr key={item.id}>
                        <td className="align-top text-muted small">
                          <strong className="d-block text-dark">
                            {item.nombre}
                          </strong>
                          {new Date(item.fechaCreacion).toLocaleString(
                            "es-co",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            },
                          )}
                        </td>
                        <td>
                          <div
                            className="bg-light border rounded p-3 text-dark"
                            style={{
                              whiteSpace: "pre-wrap",
                              fontSize: "1.05rem",
                              fontWeight: "500",
                            }}
                          >
                            {displayText}
                            {needsTruncation && (
                              <div>
                                <button
                                  className="btn btn-link p-0"
                                  onClick={() => toggleExpanded(item.id)}
                                >
                                  {isExpanded ? "Ver menos ▲" : "Ver más ▼"}
                                </button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center text-muted py-4">
                      No hay comentarios disponibles.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              <nav aria-label="Paginación de comentarios">
                <Pagination className="pagination justify-content-end mb-0">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      <i className="fas fa-angle-left" />
                    </PaginationLink>
                  </PaginationItem>
                  {[...Array(totalPages)].map((_, i) => (
                    <PaginationItem key={i} active={i + 1 === currentPage}>
                      <PaginationLink onClick={() => setCurrentPage(i + 1)}>
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      <i className="fas fa-angle-right" />
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </nav>
            </CardFooter>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default VerComentarios;
